import { useSelector } from "react-redux";


const PushpaCustomers = () => {
  const OrgId = useSelector((state) => state.auth.org_id)
  // console.log(OrgId, 'org_id__________')
  
  return (
    <div className="iframe-div">
        <iframe src= {`https://dev-discountrules.iipl.app/pushpacustomers`}
        className="iframe-style"></iframe>
    </div>
  )
};

export default PushpaCustomers;
